// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__Ca61B"};